<template>
  <div>
    <div class="clearfix_" id="publicTemplate">
      <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='banner'" class="banner" id="banner">
        <div v-if="item.selectType==1">
            <div class="banner_title">{{item.title}}</div>
            <div class="banner_remark">{{item.remark}}</div>
            <div class="banner_time">{{item.time}}</div>
        </div>
        <div class="banner_img"><img :src="item.selectType==0?item.areaPic:'http://img.source.9188cn.com/publicTemplateBanner2.png'"></div>
      </div>
      <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='recommend1'" id="recommend1">
        <div class="recommend clearfix_">
          <div @click="goto(val)" v-for="(val,idx) in item.content" :key="idx" class="recommend_img fl"><img :src="val.pic?val.pic:noImg"></div>
        </div>
      </div>
      <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='recommend2'" id="recommend2">
        <div class="recommend2 clearfix_">
          <div @click="goto(val)" v-for="(val,idx) in item.content" :key="idx" class="recommend2_img fl"><img :src="val.pic?val.pic:noImg"></div>
        </div>
      </div>
      <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='goods1'" id="goods1">
        <div class="goods1_content">
          <div class="goods1_title_box">
            <div class="goods1_title">{{item.title}}</div>
            <div class="goods1_remark">{{item.remark}}</div>
            <div class="goods1_title_bg"></div>
          </div>
          <div class="goods1_item_box clearfix_">
            <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="fl goods1_item">
              <div class="goods1_item_img"><img :src="val.pic?val.pic:noImg"></div>
              <div class="goods1_item_txt">
                <p class="goods1_item_txt_name">{{val.name}}</p>
                <p class="goods1_item_txt_price"><span>RMB：</span><i>{{val.price}}</i></p>
                <p class="goods1_item_txt_btn">点击购买</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="goods2" v-for="(item,index) in allData" :key="index" v-if="item.parentName=='goods2'||item.parentName=='goods2_copy1'||item.parentName=='goods2_copy2'">
        <div class="goods2_content">
          <div class="goods1_title_box">
            <div class="goods1_title">{{item.title}}</div>
            <div class="goods1_remark">{{item.remark}}</div>
            <div class="goods1_title_bg"></div>
          </div>
          <div class="goods1_item_box clearfix_">
            <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="fl goods1_item">
              <div class="goods1_item_img"><img :src="val.pic?val.pic:noImg"></div>
              <div class="goods1_item_txt">
                <p class="goods1_item_txt_name">{{val.name}}</p>
                <p class="goods1_item_txt_price"><span>RMB：</span><i>{{val.price}}</i></p>
                <p class="goods1_item_txt_btn">点击购买</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return{
      allData:[],
      noImg:require("@/assets/img/aa.png")
    }
  },
  mounted:function(){
    this.getProject()
  },
  methods:{
    getProject:function(){
      var t_=this
      let data = Qs.stringify({
        channel:2,
        id:'Mni_UmeBT96isjKb2qzWlQ',
        // id:this.$route.query.id,
        tamp:localStorage.tamp?localStorage.tamp:''
      });
      axios.post(`${ip}formWorkInterface/getProject`, data).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
					t_.allData=res.data.results
        }
      }).catch(err =>{
      })
    }
  }
}
</script>
<style scoped>
#publicTemplate{
    background: #fed000;
}
#banner{
    width: 100%;
    height: auto;
    margin-bottom: 6px;
    position: relative;
    background-size: 100% 100%;
}
.banner_img{
    width: 100%;
}
.banner_img img{
  width: 100%;
}
.banner_title{
    width: 100%;
    font-size: 38px;
    font-family: 'WenQuanYiMicroHei';
    color: #feffff;
    position: absolute;
    z-index: 1;
    text-align: center;
    top: 185px;
    font-family: '微软雅黑';
}
.banner_remark{
    width: 100%;
    font-family: '微软雅黑';
    font-size: 70px;
    text-align: center;
    color: #fffe18;
    position: absolute;
    z-index: 1;
    top: 275px;
}
.banner_time{
    width: 100%;
    color: #a9a9a9;
    text-align: center;
    font-size: 16px;
    font-family: '微软雅黑';
    position: absolute;
    z-index: 1;
    top: 590px;
}
#recommend1{
    width: 1442px;
    margin: 0 auto;
    position: relative;
    margin-bottom: 28px;
    padding-bottom: 0;
}
.recommend{
    width: 1442px;
    margin: 0 auto;
}
.recommend .recommend_img{
    width: 356px;
    height: 152px;
    margin-right: 5px;
}
.recommend .recommend_img:last-child{
    margin-right: 0;
}
.recommend .recommend_img img{
    width: 356px;
    height: 152px;
}
.bg_btn_box{
    background: #fff;
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 10px;
    border:1px solid #fa0;
    height: 40px;
    font-size: 12px;
}
.bg_btn_box p{
    width: 60px;
    height: 40px;
    text-align: center;
    color: #000;
    font-size: 12px;
    line-height: 40px;
    cursor: pointer;
}
#recommend2{
    width: 1308px;
    height: 640px;
    margin: 0 auto;
    background: url("http://img.source.9188cn.com/publicTemplateRecommend2.png");
    padding-top: 39px;
    position: relative;
    margin-bottom: 13px;
}
.recommend2{
    width: 1240px;
    height: 477px;
    margin: 0 auto;
}
.recommend2_img{
    width: 374px;
    height: 477px;
    margin-right: 59px;
}
.recommend2_img:last-child{
    margin-right: 0;
}
.recommend2_img img{
    width: 374px;
    height: 477px;
}
.goods1_title_box{
    width: 100%;
    height: 388px;
    position: relative;
    margin-bottom: 37px;
}
.goods1_title{
    text-align: center;
    font-size: 76px;
    color: #fff;
    margin-bottom: 45px;
}
.goods1_remark{
    text-align: center;
    font-size: 66px;
    color: #fff;
}
.goods1_title_bg{
    background: url("http://img.source.9188cn.com/goods1_title_bg.png") repeat-x;
    height: 35px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
}
.goods1_item_box{
    width: 1105px;
    margin: 0 auto;
    margin-bottom: 50px;
}
.goods1_item{
    width: 265px;
    margin-right: 14px;
    margin-bottom: 49px;
}
.goods1_item:nth-child(4n){
    margin-right: 0;
}
.goods1_item_img{
    width: 265px;
    height: 345px;
    margin-bottom: 20px;
    background: #fff;
}
.goods1_item_img img{
    width: 265px;
    height: 345px;
}
.goods1_item_txt_name{
    font-size: 16px;
    width: 100%;
    color: #fff;
    text-align: center;
    margin-bottom: 16px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.goods1_item_txt_price{
    width: 100%;
    color: #fff;
    text-align: center;
    margin-bottom: 16px;
}
.goods1_item_txt_price span{
    font-size: 16px;
}
.goods1_item_txt_price i{
    font-size: 24px;
}
.goods1_item_txt_btn{
    width: 136px;
    height: 25px;
    color: #fff;
    border: 1px solid #fff;
    text-align: center;
    line-height: 25px;
    margin: 0 auto;
}
#goods1{
    position: relative;
    margin: 0 auto;
}
.goods2{
    position: relative;
    margin: 0 auto;
}
.goods2_content{
    /*width: 1429px;*/
    background: url("http://img.source.9188cn.com/goods2_content_bg.png") no-repeat center top;
    padding-top: 262px;
}
.goods2_copy1{
    position: relative;
    margin: 0 auto;
}
.goods2_copy2{
    position: relative;
    margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/publicTemplate/index.vue